module.exports = __webpack_public_path__ + "assets/img/88e32d8345e2ab404aeae5301aeb5934.svg";